<template>
  <div>
    <vue2-org-tree
      v-if="root2 && isRender"
      :data="root2"
      :horizontal="true"
      :collapsable="true"
      :render-content="renderContent2"
      @onExpand="onExpand"
      @onNodeClick="onNodeClick"
    ></vue2-org-tree>

    <process-moreinfo-cxlcanhan
      v-if="
            isEnable &&
              selectedNodeType ===
                PROCESS_TREE.NODE_TYPE.CXL_CANHAN_PROCESS_NODE
          "
      :isOpen="isOpen"
      :process="selectedNode.data.process"
      @closeDialog="isOpen = false"
      @closed="isEnable = false"
    />
    <process-moreinfo-banhanh
      v-else-if="
            isEnable &&
              selectedNodeType === PROCESS_TREE.NODE_TYPE.INCOMING_START
          "
      :isOpen="isOpen"
      :doc="selectedNode.data.doc"
      @closeDialog="isOpen = false"
      @closed="isEnable = false"
    />
    <process-moreinfo-chuyentiep
      v-else-if="
            isEnable &&
              selectedNodeType === PROCESS_TREE.NODE_TYPE.CHUYENTIEP_NODE
          "
      :isOpen="isOpen"
      :processes="getCxlDonViProcesses(selectedNode)"
      @closeDialog="isOpen = false"
      @closed="isEnable = false"
    />
  </div>
</template>

<script>
  import Vue from "vue";
  import Vue2OrgTree from "./vue2-tree/components/org-tree";
  import vbIncomingProcessService from "../../../services/vbIncomingProcessService";
  import h from "../../../services/h";
  import constants from "../../../constants";
  import incomingDocService from "../../../services/incomingDocService";
  import utils from "../../../services/utils";
  import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
  import ProcessMoreinfoCxlcanhan from "./process-moreinfo-cxlcanhan";
  import ProcessMoreinfoBanhanh from "./process-moreinfo-banhanh";
  import ProcessMoreinfoChuyentiep from "./process-moreinfo-chuyentiep";
  import vbOutgoingDocReceiversService from "../../../services/vbOutgoingDocReceiversService";
  Vue.use(Vue2OrgTree);

  export default {
    name: "luong-xy-ly-flow",
    props: ["docId", "subDocId", "docType", "isConfigLD","isForBlockedRole", "isConfigQLVBTHVP"],
    components: {
      ProcessMoreinfoChuyentiep,
      ProcessMoreinfoBanhanh,
      ProcessMoreinfoCxlcanhan,
    },

    data() {
      return {
        PROCESS_TREE: constants.PROCESS_TREE,
        isRender: false,
        userDeptRole: null,
        historyProcesses: null,
        root2: null,
        selectedNode: null,
        isEnable: false,
        isOpen: false,
        vbIncomingDoc: null,
        listIncomingDoc: null,
        docReceivers: null
      };
    },

    computed: {
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      },
      selectedNodeType() {
        return this.selectedNode ? this.selectedNode.nodeType : null;
      }
    },

    watch: {
      isOpen(newValue) {
        newValue && (this.isEnable = newValue);
      },

      docId() {
        this.vbIncomingDoc = null;
        this.isRender = false;
        this.roots = null;
        this.historyProcesses = null;
        this.selectedNode = null;
        this.isEnable = false;
        this.isOpen = false;
        this.initData();
        // initDataForAll() ;// test
      }
    },

    created() {
      this.loadUserDeptRole().then(() =>
        this.docType === constants.DOC_TYPE.VB_DI ? this.initDataFlowOutgoingDoc() : this.initData()
      )
    },

    methods: {
      loadUserDeptRole() {
        return userDeptRoleViewService
          .findById(this.userDeptRoleId)
          .then(response => (this.userDeptRole = response.data));
      },

      initDataFlowOutgoingDoc() {
        this.loadDoc()
          .then(() => this.loadDocReceivers())
          .then(() => this.loadListIncomingDoc())
          .then(() => this.buildOutgoingDocFlow());
      },

      loadDocReceivers() {
        return vbOutgoingDocReceiversService
          .findAll({docId: this.vbIncomingDoc.vbOutgoingDocId, objectType: constants.RECEIVER_OBJECT_TYPE.DONVI})
          .then(response => this.docReceivers = response.data);
      },

      loadListIncomingDoc() {
        return incomingDocService
          .findAllByVbOutgoingDocId(this.vbIncomingDoc.vbOutgoingDocId)
          .then(response => (this.listIncomingDoc = response.data));
      },

      buildOutgoingDocFlow() {
        this.root2 = this.buildStartNode();
        this.buildOutgoingDocFlowNode(this.root2, null);
        //init expand state;
        this.$set(this.root2, "expand", true);
        h.each(this.root2.children, childNode => this.initExpandNode(childNode));
        this.isRender = true;
      },

      buildOutgoingDocFlowNode(parentNode) {
        const listIncomingDocWithDeptName = this.listIncomingDoc.filter(item => item.toDeptName)

        let childrenNodes = h.collect(listIncomingDocWithDeptName, vbIncomingDoc =>
          this.buildDonViBanHanhNode({}, vbIncomingDoc)
        );
        this.$set(parentNode, "children", childrenNodes);
      },

      buildDonViBanHanhNode(treeNode, vbIncomingDoc) {
        treeNode.id = vbIncomingDoc.id;
        treeNode.expand = true;
        treeNode.vbIncomingDoc = vbIncomingDoc;
        treeNode.nodeType = constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANH_NODE;
        if (
          vbIncomingDoc.status === constants.INCOMING_DOC_STATUS.TU_CHOI_TIEP_NHAN
        ) {
          treeNode.children = [this.buildTuChoiTiepNhanNode()];
        }
        return treeNode;
      },

      buildTuChoiTiepNhanNode() {
        // console.log("buildTuChoiTiepNhanNode");
        return {
          id: constants.PROCESS_TREE.NODE_TYPE.TUCHOITIEPNHAN_NODE,
          expand: false,
          type: constants.PROCESS_TREE.NODE_TYPE.TUCHOITIEPNHAN_NODE
        };
      },

      initData() {
        this.loadDoc()
          .then(() => this.getHistoryProcesses())
          .then(() => {this.buildProcessesTree()});
      },

      getHistoryProcesses() {
        let promise;
        if (this.isConfigLD) {
          promise = vbIncomingProcessService
            .getHistoryProcessesForConfigLD(this.vbIncomingDoc.id, this.subDocId)
        } else if (this.isForBlockedRole) {
          promise = vbIncomingProcessService.getHistoryProcessesForBlockedRole(this.vbIncomingDoc.id)
        } else if (this.isConfigQLVBTHVP) {
          promise = vbIncomingProcessService.getHistoryProcessesForConfigTHVP(this.vbIncomingDoc.id)
        } else {
          promise = vbIncomingProcessService
            .getHistoryProcesses(this.vbIncomingDoc.id, this.subDocId)
        }
        return promise.then(response => (this.historyProcesses = response.data));
      },

      buildProcessesTree() {
        this.root2 = this.buildStartNode();
        this.buildCxlProcessNode(this.root2, null);
        //init expand state;
        this.$set(this.root2, "expand", true);
        h.each(this.root2.children, childNode => this.initExpandNode(childNode));
        this.isRender = true;
      },

      initExpandNode(node) {
        h.each(node.children, childNode => this.initExpandNode(childNode));
        let expand;
        expand =
          h.exists(node.children, childNode => childNode.expand) ||
          h.exists(
            node.children,
            childNode =>
              childNode.nodeType ===
              constants.PROCESS_TREE.NODE_TYPE.CXL_CANHAN_PROCESS_NODE &&
              childNode.data.process.receiverId === this.userDeptRole.userId
          );
        this.$set(node, "expand", expand);
      },

      /**
       * co the la node ban hanh hoac chuyen tiep don vi
       */
      buildStartNode() {
        return {
          nodeType: constants.PROCESS_TREE.NODE_TYPE.INCOMING_START,
          data: {doc: this.vbIncomingDoc},
          expand: false
        };
      },

      buildCxlProcessNode(parentNode, parentId) {
        let processCxlCaNhan = h.findAll(
          this.historyProcesses,
          process =>
            process.parentId === parentId &&
            process.stepType === constants.STEP.STEP_TYPE.CANHAN
        );

        let cxlDonViProcesses = h.findAll(
          this.historyProcesses,
          process =>
            process.parentId === parentId &&
            process.stepType === constants.STEP.STEP_TYPE.DONVI
        );
        let childrenNodes = [];
        if (cxlDonViProcesses && cxlDonViProcesses.length)
          childrenNodes.push(
            ...this.buildProcessChuyenTiepDonVi(cxlDonViProcesses)
          );

        if (processCxlCaNhan && processCxlCaNhan.length)
          childrenNodes.push(
            ...this.buildCxlCaNhanProcessNodes(processCxlCaNhan)
          );
        this.$set(parentNode, "children", childrenNodes);
      },

      buildCxlCaNhanProcessNodes(processCxlCaNhan) {
        return h.collect(processCxlCaNhan, process => {
          let processNode = {
            nodeType: constants.PROCESS_TREE.NODE_TYPE.CXL_CANHAN_PROCESS_NODE,
            data: {process: process},
            expand: false
          };
          this.buildCxlProcessNode(processNode, process.id);
          return processNode;
        });
      },

      buildCxlDonViProcessNode(parentNode) {
      },

      buildProcessChuyenTiepDonVi(cxlDonViProcesses) {
        let chuyenTiepNode = {
          nodeType: constants.PROCESS_TREE.NODE_TYPE.CHUYENTIEP_NODE,
          children: h.collect(cxlDonViProcesses, process => {
            let processNode = {
              nodeType: constants.PROCESS_TREE.NODE_TYPE.CXL_DONVI_PROCESS_NODE,
              data: {process: process},
              expand: false
            };
            this.buildCxlDonViProcessNode(processNode);
            return processNode;
          }),
          expand: false
        };
        return [chuyenTiepNode];
      },

      buildShortName(fullName) {
        return utils.buildShortName(fullName);
      },

      loadDoc() {
        if(this.isConfigLD) {
          return incomingDocService
            .findByIdForConfigLD(this.docId, this.subDocId)
            .then(response => (this.vbIncomingDoc = response.data));
        } else if (this.isForBlockedRole) {
           return  incomingDocService
             .findByIdForBlockedRole(this.docId, this.$store.getters.lockedUserDeptRole.userId)
             .then(response => (this.vbIncomingDoc = response.data));
        }
        return incomingDocService
          .findById(this.docId, this.subDocId)
          .then(response => (this.vbIncomingDoc = response.data));
      },

      getProcessTypeLabel(processType) {
        switch (processType) {
          case constants.PROCESS_TYPE.CHUTRI:
            return "Chủ trì";
          case constants.PROCESS_TYPE.NHANDEBIET:
            return "Nhận để biết";
          case constants.PROCESS_TYPE.PHOIHOP:
            return "Phối hợp";
          case constants.PROCESS_TYPE.LĐ_CHI_DAO:
            return "Lãnh đạo chỉ đạo"
          case constants.PROCESS_TYPE.XIN_Y_KIEN_LĐ:
            return "Xin ý kiến lãnh đạo"
          default:
            return "";
        }
      },

      renderContent2(h, data) {
        switch (data.nodeType) {
          case constants.PROCESS_TREE.NODE_TYPE.INCOMING_START:
            return this.renderIncomingStartNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.CXL_DONVI_PROCESS_NODE:
            return this.renderCxlDonViProcessNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.CXL_CANHAN_PROCESS_NODE:
            return this.renderCxlCaNhanProcessNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.CHUYENTIEP_NODE:
            return this.renderChuyenTiepNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANH_NODE:
            return this.renderDonViBanHanhNode(h, data);
          default:
            return null;
        }
      },


      getProcessTypeByDeptId(deptId) {
        let docReceiver = h.find(this.docReceivers, item => item.objectId === deptId);
        return docReceiver ? docReceiver.receiveType : null;
      },

      renderDonViBanHanhNode(h, data) {
        let vbIncomingDoc = data.vbIncomingDoc;
        let toDeptName = vbIncomingDoc.toDeptName;
        let isRead =
          vbIncomingDoc.status !== constants.INCOMING_DOC_STATUS.TAO_MOI;
        let classes = ["node_handlder flex-row flex__center"];
        let components = [];
        let typeClassTag;
        let processType = this.getProcessTypeByDeptId(vbIncomingDoc.toDeptId);
        let processTypeLabel;
        switch (processType) {
          case constants.PROCESS_TYPE.CHUTRI:
            typeClassTag = "tag-chuTri";
            processTypeLabel = "Chủ trì";
            break;
          case constants.PROCESS_TYPE.PHOIHOP:
            typeClassTag = "tag-phoiHop";
            processTypeLabel = "Phối hợp";
            break;
          case constants.PROCESS_TYPE.NHANDEBIET:
            typeClassTag = "tag-nhanDeBiet";
            processTypeLabel = "Nhận để biết";
            break;
          case constants.PROCESS_TYPE.LĐ_CHI_DAO:
            typeClassTag = "tag-lanhDaoChiDao";
            processTypeLabel = "Lãnh đạo chỉ đạo";
            break;
          case constants.PROCESS_TYPE.XIN_Y_KIEN_LĐ:
            typeClassTag = "tag-xinYKienLanhDao";
            processTypeLabel = "Xin ý kiến lãnh đạo";
            break;
        }
        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "profileIsRead"}, [
              h("div", {class: "avatar_fake flex-row flex__center"}, [
                h("span", this.buildShortName(toDeptName))
              ]),
              isRead
                ? h("i", {
                  class:
                    "far fa-check-circle font-size__medium icon-read border-radius__50"
                })
                : null
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, toDeptName)
              // h("div", {class: "more-info font-size__small"}, data.moreInfo)
            ]),
            typeClassTag ? h(
              "div",
              {class: `tag ${typeClassTag}`},
              processTypeLabel
            ) : null
          ])
        );
        return h("div", {class: classes.join(" ")}, components);
      },

      renderCxlCaNhanProcessNode(h, data) {
        let process = data.data.process;
        let classes = ["node_handlder flex-row flex__center"];
        this.userDeptRole.userId === process.receiverId && classes.push("active");

        let components = [];
        let typeClassTag = "";
        if (process.processType === constants.PROCESS_TYPE.CHUTRI) {
          typeClassTag = "tag-chuTri";
        } else if (process.processType === constants.PROCESS_TYPE.NHANDEBIET) {
          typeClassTag = "tag-nhanDeBiet";
        } else if (process.processType === constants.PROCESS_TYPE.PHOIHOP) {
          typeClassTag = "tag-phoiHop";
        }else if (process.processType === constants.PROCESS_TYPE.LĐ_CHI_DAO){
          typeClassTag = 'tag-lanhDaoChiDao'
        }else if (process.processType === constants.PROCESS_TYPE.XIN_Y_KIEN_LĐ){
          typeClassTag = 'tag-xinYKienLanhDao'
        }

        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "profileIsRead"}, [
              h("div", {class: "avatar_fake flex-row flex__center"}, [
                h("span", this.buildShortName(process.receiverName))
              ]),
              process.isRead
                ? h("i", {
                  class:
                    "fas fa-check-circle font-size__medium icon-read border-radius__50"
                })
                : null
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, process.receiverName),
              h(
                "div",
                {class: "more-info font-size__small"},
                process.receiverPosName
              )
            ]),
            h(
              "div",
              {class: `tag ${typeClassTag}`},
              this.getProcessTypeLabel(process.processType)
            )
          ])
        );
        return h("div", {class: classes.join(" ")}, components);
      },

      renderCxlDonViProcessNode(h, data) {
        let process = data.data.process;
        let classes = ["node_handlder flex-row flex__center"];

        let components = [];
        let typeClassTag = "";
        if (process.processType === constants.PROCESS_TYPE.CHUTRI) {
          typeClassTag = "tag-chuTri";
        } else if (process.processType === constants.PROCESS_TYPE.NHANDEBIET) {
          typeClassTag = "tag-nhanDeBiet";
        } else if (process.processType === constants.PROCESS_TYPE.PHOIHOP) {
          typeClassTag = "tag-phoiHop";
        }else if (process.processType === constants.PROCESS_TYPE.LĐ_CHI_DAO){
          typeClassTag = 'tag-lanhDaoChiDao'
        } else if (process.processType === constants.PROCESS_TYPE.XIN_Y_KIEN_LĐ){
          typeClassTag = 'tag-xinYKienLanhDao'
        }

        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "avatar_fake flex-row flex__center"}, [
              h("span", this.buildShortName(process.deptReceiverName))
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, process.deptReceiverName)
            ]),
            h(
              "div",
              {class: `tag ${typeClassTag}`},
              this.getProcessTypeLabel(process.processType)
            )
          ])
        );

        return h("div", {class: classes.join(" ")}, components);
      },

      renderChuyenTiepNode(h, data) {
        return h("div", {class: "node_label clickable"}, [
          h("span", "Chuyển tiếp")
        ]);
      },

      renderIncomingStartNode(h, data) {
        let doc = data.data.doc;
        let publisherName = doc.publisherName || doc.outsidePublisherName;
        let classes = ["node_handlder flex-row flex__center"];
        let components = [];
        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "avatar_fake flex-row flex__center"}, [
              h("span", this.buildShortName(publisherName))
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, publisherName)
              // h("div", {class: "more-info font-size__small"}, data.moreInfo)
            ]),
            h("div", {class: "tag tag-banHanh"}, "Ban hành")
          ])
        );

        return h("div", {class: classes.join(" ")}, components);
      },

      onExpand(data) {
        this.$set(data, "expand", !data.expand);
        this.isRender = false;
        this.$nextTick(() => (this.isRender = true));
      },

      onNodeClick(event, data) {
        this.isOpen = true;
        this.selectedNode = data;
        if (
          this.selectedNode.nodeType ===
          constants.PROCESS_TREE.NODE_TYPE.CXL_DONVI_PROCESS_NODE
        ) {
          this.$emit("showSubDocProcessFlow", {process: this.selectedNode.data.process});
        } else if (
          this.selectedNode.nodeType ===
          constants.PROCESS_TREE.NODE_TYPE.INCOMING_START
        ) {
          this.isOpen = false;
          this.selectedNode.data.doc.forwardIncomingDocId && this.$emit("showForwardIncomingDoc", {doc: this.selectedNode.data.doc});
          this.selectedNode.data.doc.vbOutgoingDocId && this.$emit("showVbOutgoingDocFlow", {doc: this.selectedNode.data.doc});
        } else if (
          this.selectedNode.nodeType ===
          constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANH_NODE
        ) {
          this.$emit("showIncomingDocFlow", {doc: this.selectedNode.vbIncomingDoc});
        }
      },

      initDataForAll() {
        this.loadDoc()
          .then(() => this.getHistoryProcessesForAll())
          .then((res) => {
            this.buildProcessesTreeForAll(JSON.parse(JSON.stringify(res)))
          });
      },

      getHistoryProcessesForAll() {
        let promise;
        if (this.isConfigLD) {
          promise = vbIncomingProcessService
            .getHistoryProcessesForConfigLD(this.vbIncomingDoc.id, this.subDocId)
        } else {
          promise = vbIncomingProcessService
            .getAllHistoryProcess(this.vbIncomingDoc.id, this.subDocId)
        }
        return promise.then(response => (this.historyProcesses = response.data));
      },

      buildProcessesTreeForAll(processAll) {
        this.root2 = this.buildStartNodeForAll();
        this.buildCxlProcessNodeAll(this.root2, null, processAll);
        //init expand state;
        this.$set(this.root2, "expand", true);
        // h.each(this.root2.children, childNode => this.initExpandNode(childNode));
        this.isRender = true;
      },

      buildStartNodeForAll() {
        return {
          nodeType: constants.PROCESS_TREE.NODE_TYPE.INCOMING_START,
          data: {doc: this.vbIncomingDoc},
          expand: true,
          children: []
        };
      },

      buildCxlProcessNodeAll(parentNode, parentId, processAll) {
        console.log("processAll:",processAll)
        this.pushNodeDept(parentNode, this.getListDeptProcess(processAll.vbIncomingProcessList), processAll.childs)
        this.pushNodeIndividual(parentNode, this.getListIndividualProcess(processAll.vbIncomingProcessList), processAll.childs)
      },

      pushNodeDept(parentNode, cxlDeptProcesses, childs){
        cxlDeptProcesses.forEach(process => {
          let deptNode = {
            nodeType: constants.PROCESS_TREE.NODE_TYPE.CXL_DONVI_PROCESS_NODE,
            data: {process: process},
            expand: true,
            children: []
          };
          parentNode.children.push(deptNode)

          if(childs.length > 0){
            let existChild = childs.find(child => child.deptId === process.deptReceiverId)

            if(existChild) {
              this.pushNodeDept(deptNode, this.getListDeptProcess(existChild.vbIncomingProcessList), existChild.childs)
              this.pushNodeIndividual(deptNode, this.getListIndividualProcess(existChild.vbIncomingProcessList), existChild.childs)
            }
          }
        })

      },

      pushNodeIndividual(parentNode, cxlIndividualProcesses, childs){
        cxlIndividualProcesses.forEach(process => {
          let processNode = {
            nodeType: constants.PROCESS_TREE.NODE_TYPE.CXL_CANHAN_PROCESS_NODE,
            data: {process: process},
            expand: false,
            children: []
          };
          parentNode.children.push(processNode)
          if(childs.length > 0) {
            let existChild = childs.find(child => child.deptId === process.deptReceiverId)

            if(existChild) {
              this.pushNodeDept(processNode, this.getListDeptProcess(existChild.vbIncomingProcessList), existChild.childs)
              this.pushNodeIndividual(processNode, this.getListIndividualProcess(existChild.vbIncomingProcessList), existChild.childs)
            }
          }
        })
      },

      getListDeptProcess(process) {
        return h.findAll(
          process,
          process =>
            process.stepType === constants.STEP.STEP_TYPE.DONVI
        );
      },

      getListIndividualProcess(process) {
        return h.findAll(
          process,
          process =>
            process.stepType === constants.STEP.STEP_TYPE.CANHAN
        );
      },

      getCxlDonViProcesses(node) {
        let processes = [];
        h.each(node.children, childNode => {
          if (
            childNode.nodeType ===
            constants.PROCESS_TREE.NODE_TYPE.CXL_DONVI_PROCESS_NODE
          )
            processes.push(childNode.data.process);
        });
        return processes;
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/luong-xu-ly-flow.vue